<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto">
      <notifications group="error" position="top center" class="mt-1" />
      <notifications group="success" position="top left" class="mt-1" />
      <notifications group="info" position="top left" class="mt-1" />
      <notifications group="warn" position="top left" class="mt-1" />
      <loading v-if="vLoading" />
    </v-col>

    <b-card header-bg-variant="primary" header-text-variant="white">
      <v-row>
        جهت مشاهده گزارش درخواست‌های ثبت شده، بازه تاریخ ثبت را مشخص کنید و سپس
        با دکمه جستجو، نتیجه را مشاهده کنید. میتوانید با استفاده از دکمه‌های
        زیر، تاریخ را به صورت سریع تنظیم کنید.
      </v-row>
      <v-row class="p-0">
        <v-col cols="4">
          <date-picker
            placeholder="تاریخ شروع"
            v-model="startDate"
            :editable="true"
          ></date-picker
        ></v-col>
        <v-col cols="4">
          <date-picker
            placeholder="تاریخ پایان"
            v-model="endDate"
            :editable="true"
          ></date-picker
        ></v-col>
        <v-col cols="4">
          <b-btn class="btn btn-dark" @click="getItems(true)">جستجو</b-btn>
        </v-col>
      </v-row>
      <v-row>
        <b-btn class="btn btn-primary mx-1" @click="setDate(7, 'days')"
          >یک هفته اخیر</b-btn
        >
        <b-btn class="btn btn-primary mx-1" @click="setDate(1, 'months')"
          >یک ماه اخیر</b-btn
        >
        <b-btn class="btn btn-primary mx-1" @click="setDate(6, 'months')"
          >شش ماه اخیر</b-btn
        >
        <b-btn class="btn btn-primary mx-1" @click="setDate(12, 'months')"
          >یک سال اخیر</b-btn
        >
      </v-row>
      <div v-if="reportLevel">
        <hr />
        <b-row>
          <b-col cols="4">
            <b-btn
              class="btn btn-primary mx-1"
              @click="changeChartType('logarithmic')"
              >نمودار لگاریتمی</b-btn
            >
            <b-btn
              class="btn btn-primary mx-1"
              @click="changeChartType('linear')"
              >نمودار خطی</b-btn
            >
          </b-col>
          <!-- <b-col cols="8">
            <b-btn
              class="btn btn-primary mx-1"
              @click="changeChartUnitPrice(1, 0)"
              >ریال</b-btn
            >
            <b-btn
              class="btn btn-primary mx-1"
              @click="changeChartUnitPrice(10, 0)"
              >تومان</b-btn
            >
            <b-btn
              class="btn btn-primary mx-1"
              @click="changeChartUnitPrice(1000000, 1)"
              >میلیون تومان</b-btn
            >
            <b-btn
              class="btn btn-primary mx-1"
              @click="changeChartUnitPrice(10000000, 2)"
              >میلیارد تومان</b-btn
            >
          </b-col> -->
        </b-row>
      </div>
      <div v-if="reportLevel == 1">
        <div v-for="result in results" :key="result.title">
          <b-row class="mt-5">
            شما در حال مشاهده گزارش اقلامی هستید که در بازه
            {{ selectedStartDate }}
            لغایت
            {{ selectedEndDate }}
            در سامانه به ثبت رسیده‌اند و واحد اندازه‌گیری آنها
            {{ result.title }}
            است.
          </b-row>
          <v-row>
            <v-col cols="8">
              <bar-chart
                v-if="renderCharts"
                :chartdata="result.report.statusDetailsCount"
                :options="statusDetailsCountOptions"
              >
              </bar-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
            <v-col cols="4">
              <pie-chart
                v-if="renderCharts"
                :chartdata="result.report.assigneeDetailsCount"
                :options="assigneeDetailsOptions"
              >
              </pie-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <bar-chart
                v-if="renderCharts"
                :chartdata="result.report.statusDetailsPrice"
                :options="statusDetailsPriceOptions"
              >
              </bar-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
            <v-col cols="4">
              <pie-chart
                v-if="renderCharts"
                :chartdata="result.report.assigneeDetailsPrice"
                :options="assigneeDetailsPriceOptions"
              >
              </pie-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
          </v-row>
          <v-row v-if="result.report.itemDetails.length">
            <b-table
              responsive
              show-empty
              :items="result.report.itemDetails"
              :fields="itemFields"
              :current-page="itemCurrentPage"
              :per-page="itemPerPage"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
            >
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ (itemCurrentPage - 1) * itemPerPage + data.index + 1 }}
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(number)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value.toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(totalCount)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value.toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(description)="data">
                <div style="text-align: center; vertical-align: middle">
                  <b-btn class="url" @click="getDescriptionItems(data.item)">{{
                    data.value
                  }}</b-btn>
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="itemCurrentPage"
              :total-rows="result.report.itemDetails.length"
              :per-page="itemPerPage"
              aria-controls="customers-tabel"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </v-row>
        </div>
      </div>

      <div v-if="reportLevel == 2">
        <div v-for="result in results" :key="result.title">
          <v-row class="mt-5">
            شما در حال مشاهده گزارش اقلامی هستید که در بازه
            {{ selectedStartDate }}
            لغایت
            {{ selectedEndDate }}
            در سامانه به ثبت رسیده‌اند و شرح کالای آنها
            {{ selectedDescription }}
            و واحد اندازه‌گیری آنها
            {{ result.title }}
            است.
          </v-row>
          <v-row>
            <b-btn @click="getItems(false)">بازگشت به گزارش تجمیعی</b-btn>
          </v-row>
          <v-row>
            <v-col cols="8">
              <bar-chart
                v-if="renderCharts"
                :chartdata="result.report.statusDetailsCount"
                :options="statusDetailsCountOptions"
              >
              </bar-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
            <v-col cols="4">
              <pie-chart
                v-if="renderCharts"
                :chartdata="result.report.assigneeDetailsCount"
                :options="assigneeDetailsOptions"
              >
              </pie-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <bar-chart
                v-if="renderCharts"
                :chartdata="result.report.statusDetailsPrice"
                :options="statusDetailsPriceOptions"
              >
              </bar-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
            <v-col cols="4">
              <pie-chart
                v-if="renderCharts"
                :chartdata="result.report.assigneeDetailsPrice"
                :options="assigneeDetailsPriceOptions"
              >
              </pie-chart>
              <b-spinner
                v-else-if="reportLevel"
                class="align-middle"
              ></b-spinner>
            </v-col>
          </v-row>
          {{result.report.itemDetails.length}}
          <v-row v-if="result.report.itemDetails.length">
            <b-table
              responsive
              show-empty
              :items="result.report.itemDetails"
              :fields="descriptionFields"
              :current-page="descriptionCurrentPage"
              :per-page="descriptionPerPage"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
            >
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{
                    (descriptionCurrentPage - 1) * descriptionPerPage +
                    data.index +
                    1
                  }}
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(number)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value.toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(totalCount)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value.toLocaleString() }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="descriptionCurrentPage"
              :total-rows="result.report.itemDetails.length"
              :per-page="descriptionPerPage"
              aria-controls="customers-tabel"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </v-row>
          <v-row class="mt-5">
            <b-btn @click="getItems(false)">بازگشت به گزارش تجمیعی</b-btn>
          </v-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import BarChart from "/src/components/charts/BarExample.vue";
import PieChart from "/src/components/charts/PieExample.vue";
import LineChart from "/src/components/charts/LineExample.vue";
import M from "minimatch";

export default {
  components: {
    BarChart,
    PieChart,
    LineChart,
    datePicker: VuePersianDatetimePicker,
  },
  data: function () {
    return {
      vLoading: false,
      guide: false,
      isBusy: false,
      renderCharts: false,
      reportLevel: 0,
      dashboard: {},

      striped: true,
      startDate: moment(new Date())
        .subtract(30, "days")
        .format("jYYYY/jMM/jDD"),
      selectedStartDate: "",
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      selectedEndDate: "",
      results: [],
      itemDetails: [],
      statusDetailsCount: {},
      statusDetailsPrice: {},
      assigneeDetailsCount: {},
      assigneeDetailsPrice: {},
      itemFields: [
        { key: "index", label: "#" },
        { key: "description", sortable: true, label: "شرح کالا" },
        { key: "number", sortable: true, label: "دفعات سفارش" },
        { key: "totalCount", sortable: true, label: "مجموع حجم سفارش" },
      ],
      descriptionFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح کالا" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", sortable: true, label: "دفعات سفارش" },
        { key: "totalCount", sortable: true, label: "مجموع حجم سفارش" },
      ],
      itemCurrentPage: 1,
      itemPerPage: 10,
      selectedDescription: "",
      descriptionItems: [],
      descriptionModal: false,
      descriptionLoading: false,
      descriptionCurrentPage: 1,
      descriptionPerPage: 5,
      myType: "logarithmic",
      unit: 1,
      precision: 0,

      statusDetailsCountOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "اقلام استعلا‌م‌ها به تفکیک وضعیت",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "اقلام استعلا‌م‌ها به تفکیک وضعیت",
                fontFamily: "iransans",
              },
              type: "linear",
              ticks: {
                fontFamily: "iransans",
                callback: function (value) {
                  return value.toLocaleString();
                },
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "وضعیت",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
          callbacks: {
            label: function (tooltipItems, data) {
              return tooltipItems.yLabel.toLocaleString() + " قلم";
            },
          },
        },
      },

      statusDetailsPriceOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "مبلغ اقلام استعلا‌م‌ها به تفکیک وضعیت",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "مبلغ اقلام استعلا‌م‌ها - میلیون تومان",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
                callback: function (value) {
                  return (parseInt(value / 10 / 10000) / 100).toLocaleString();
                },
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "وضعیت",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                (
                  parseInt(tooltipItems.yLabel / 10 / 10000) / 100
                ).toLocaleString() + " میلیون تومان"
              );
            },
          },
        },
      },

      assigneeDetailsOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "اقلام سفارش‌ها به تفکیک کارشناس",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "left",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                data.labels[tooltipItems.index] +
                ": " +
                data.datasets[tooltipItems.datasetIndex].data[
                  tooltipItems.index
                ].toLocaleString() +
                " قلم"
              );
            },
          },
        },
      },

      assigneeDetailsPriceOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "مبلغ اقلام سفارش‌ها به تفکیک کارشناس",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "left",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                data.labels[tooltipItems.index] +
                ": " +
                (
                  data.datasets[tooltipItems.datasetIndex].data[
                    tooltipItems.index
                  ] /
                  10 /
                  1000 /
                  1000
                ).toLocaleString() +
                " میلیون تومان"
              );
            },
          },
        },
      },
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },

    setDate(number, unit) {
      this.startDate = moment(new Date())
        .subtract(number, unit)
        .add(1, "days")
        .format("jYYYY/jMM/jDD");
      this.endDate = moment(new Date()).format("jYYYY/jMM/jDD");
    },

    getItems(mode) {
      this.vLoading = true;

      if (mode) {
        this.selectedStartDate = JSON.parse(JSON.stringify(this.startDate));
        this.selectedEndDate = JSON.parse(JSON.stringify(this.endDate));
      } else {
        this.startDate = JSON.parse(JSON.stringify(this.selectedStartDate));
        this.endDate = JSON.parse(JSON.stringify(this.selectedEndDate));
      }

      Axios.post(
        this.baseUrl + "/ppkpms/office/reports/orderItemsByOrder",
        {
          start: this.startDate + "00:00",
          end: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.renderCharts = false;
          this.vLoading = false;
          if (res.status == 200) {
            this.reportLevel = 1;
            this.results = res.data;
            // this.itemDetails = this.results.itemDetails;
            // this.statusDetailsCount = this.results.statusDetailsCount;
            // this.statusDetailsPrice = this.results.statusDetailsPrice;
            // this.assigneeDetailsCount = this.results.assigneeDetailsCount;
            // this.assigneeDetailsPrice = this.results.assigneeDetailsPrice;
            setTimeout(() => {
              this.renderCharts = true;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.vLoading = false;
        });
    },
    getDescriptionItems(description) {
      this.startDate = JSON.parse(JSON.stringify(this.selectedStartDate));
      this.endDate = JSON.parse(JSON.stringify(this.selectedEndDate));
      this.vLoading = true;
      this.selectedDescription = description.description;
      this.descriptionCurrentPage = 1;
      this.descriptionModal = true;
      this.descriptionLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/office/reports/orderItemsByOrderDescription",
        {
          start: this.startDate + "00:00",
          end: this.endDate + "23:59",
          description: this.selectedDescription,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.renderCharts = false;
          this.vLoading = false;
          if (res.status == 200) {
            this.reportLevel = 2;
            this.results = res.data;
            // this.descriptionItems = this.results.itemDetails;
            // this.statusDetailsCount = this.results.statusDetailsCount;
            // this.statusDetailsPrice = this.results.statusDetailsPrice;
            // this.assigneeDetailsCount = this.results.assigneeDetailsCount;
            // this.assigneeDetailsPrice = this.results.assigneeDetailsPrice;
            setTimeout(() => {
              this.renderCharts = true;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.vLoading = false;
        });
    },

    changeChartType(newType) {
      this.renderCharts = false;
      this.statusDetailsCountOptions.scales.yAxes[0].type = newType;
      this.statusDetailsPriceOptions.scales.yAxes[0].type = newType;
      setTimeout(() => {
        this.renderCharts = true;
      }, 330);
    },

    // changeChartUnitPrice(value, unit, precision) {
    //   var mydata = value;
    //   console.log(mydata);
    //   mydata = parseInt(mydata / unit) / Math.pow(10, precision);
    //   console.log(mydata);
    // },
  },

  mounted() {},
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

